module.exports = __webpack_public_path__ + "static/media/vollDammCup.8e0ab34d.jpg";